module.exports = __webpack_public_path__ + "img/fire3.2a060a05.jpg";